// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store';
import "./router/auth"  //用户进行前端的权限控制
import 'element-ui/lib/theme-chalk/index.css'
import ElementUI from 'element-ui'
import Tree from 'element-ui'
import Container from 'element-ui'
import ScrollBar from 'element-ui'
import * as echarts from 'echarts';
import * as Common from '@/utils/common'
import * as Dict from "@/utils/dict"
import * as Api from "@/utils/api"
import areaList from "@/components/public/AreaList"
Vue.component("areaList",areaList)
Vue.prototype.Common = Common
Vue.prototype.Dict = Dict
Vue.prototype.Api = Api
Vue.prototype.echarts = echarts
//图片上传地址。
// Vue.prototype.fileAction = "http://192.168.0.134:8062/"
Vue.prototype.fileAction = "http://admin.zhejiangzhongchong.com/proxy_api/"
Vue.use(ElementUI, {
  size: 'medium'
})

Vue.use(Tree)
Vue.use(Container)
Vue.use(ScrollBar)
Vue.config.productionTip = false
//自定义命令
Vue.directive("has", {
  inserted: function(el, binding) {
    if(!store.getters.isVisible(binding.value)){
      console.log(el)
      el.parentNode && el.parentNode.removeChild(el)
    }
  }
});
new Vue({
  el: '#app',
  router,
  store,
  components: {App},
  template: '<App/>'
})

Vue.config.errorHandler = function (err, vm, info) {
  console.log("%%%%%%%%%%%%%", err)
}



// WEBPACK FOOTER //
// ./src/main.js